import React, { Component } from 'react';
import BlockContent from '@sanity/block-content-to-react';
import { Link } from 'gatsby';
import StarRatings from 'react-star-ratings';
import Flickity from './Flickity';

const MAX_STARS = 5;
const STAR_SVG_SHAPE = 'M11.5384 16.5622L4.74 20L6.05965 12.7573L0.538379 7.63932L8.15234 6.60089L11.5384 0L14.9244 6.60089L22.5384 7.63932L17.0171 12.7573L18.3368 20L11.5384 16.5622Z';
const STAR_SVG_BOX = '0 0 23 20';
const STAR_SIZE = '19px';
const STAR_SPACING = '3px';

const SLIDE_OPTIONS = {
	cellAlign: 'left',
	contain: true,
	wrapAround: false,
	pageDots: false,
	prevNextButtons: false,
	selectedAttraction: 0.1,
	friction: 0.8,
	imagesLoaded: true,
};


export default class FeaturedReviews extends Component  {

	constructor() {
		super();
		this.sliders = [];
	}

	onSetSliderRef = sliderRef => {
		this.sliders.push(sliderRef);
	}

	onClickPrevious = () => {
		this.sliders.forEach(slider => slider.previous());
	}

	onClickNext = () => {
		this.sliders.forEach(slider => slider.next());
	}

	render() {
		const {
			title,
			reviews = []
		} = this.props;


		return (
			<section className='mt6 mb6 mt12--md mb12--md of--hidden'>
				<div className="grid-container contained">
				<div className="tc tl--md">
					<h2 className="domaine--large">{title}</h2>
				</div>
				</div>

				<div className="mt6 mt8--lg">
					<div className="grid-container contained product-carousel pr">
						<Flickity
							sliderRef={this.onSetSliderRef}
							options={SLIDE_OPTIONS}>
							{reviews.map(review => (
								<div
									className="featured-review__container"
									key={review._key}>
									<StarRatings
										rating={review.rating}
										numberOfStars={MAX_STARS}
										starRatedColor="#000"
										starEmptyColor="#fff"
										svgIconPath={STAR_SVG_SHAPE}
										svgIconViewBox={STAR_SVG_BOX}
										starDimension={STAR_SIZE}
										starSpacing={STAR_SPACING}
									/>

									<div className='mt2 rich-text'>
										<BlockContent blocks={review.review} />
									</div>

									<p className="domaine--small">{review.fullName}</p>
									<div className='featured-review__verified'>
										<img src="/images/icon-verified.svg" alt="Verified Buyer" className='featured-review__verified-icon dib' />
										<p className='color--gray-text uppercase sans--xsmall dib'>Verified Buyer</p>
									</div>

									{review.productSlug && (
										<Link to={`/products/${review.productSlug}`} className='featured-review__link mt2'>
											<p className='sans--small pr2'>{review.product}</p>
											<img
												className="featured-review__link-icon"
												alt="next"
												src="/images/icon-carousel-next.svg"
											/>
										</Link>
									)}
								</div>
							))}
						</Flickity>
						<button
							className='hide--md'
							title="Previous"
							name="previous"
							onClick={this.onClickPrevious}>
							<img
								className="db flip m--auto"
								alt="next"
								src="/images/icon-carousel-next.svg"
							/>
						</button>
						<button
							className='hide--md'
							title="Next"
							name="next"
							onClick={this.onClickNext}>
							<img
								className="db m--auto"
								alt="next"
								src="/images/icon-carousel-next.svg"
							/>
						</button>
					</div>
				</div>
			</section>
		);
	}
}